import { lazyView } from '../platform/index.ts';

export { CopyButton, oneMcpUrl, useMarketplace } from './admin/mcp-config.tsx';
export {
  NEW_PROJECT_SLUG,
  canCreateProjectIn,
  createProject,
  projectSlugFor,
} from './admin/project-create.ts';
export { isValidBranchName } from './branch-names.ts';
export { errorMessage, type Branch, type Project } from './workspace.ts';

/** Its pages and views the host (or another module) loads when shown. */
export const pages = {
  Alerts: () => import('./Alerts.tsx'),
  'admin/Organizations': () => import('./admin/Organizations.tsx'),
  'admin/Projects': () => import('./admin/Projects.tsx'),
  'admin/Settings': () => import('./admin/Settings.tsx'),
  'dashboard/Dashboard': () => import('./dashboard/Dashboard.tsx'),
  'pages/Branches': () => import('./pages/Branches.tsx'),
};

/** Its branch dialogs (the code pages and the apps open them), loaded when shown. */
export const CreateBranchModal = lazyView(
  async () => (await import('./pages/Branches.tsx')).CreateBranchModal,
);
export const DeleteDialog = lazyView(async () => (await import('./pages/Branches.tsx')).DeleteDialog);
